


import {
   Component,
   EventEmitter,
   HostBinding,
   Input,
   OnInit,
   Output,
   ChangeDetectorRef,
   ViewChild
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OTPMailResponse } from 'src/app/models/user/otp-mail.model';
import { VerificationMailResponse } from 'src/app/models/user/verification-mail.model';
import { VerifyOTPResponse } from 'src/app/models/user/verify-otp.model';
import { AnalyticsUtils } from 'src/app/shared/services/analytics-utils';
import { AuthService } from 'src/app/shared/services/auth.service';
import { DataLayerService } from 'src/app/shared/services/data-layer.service';
import { SharedService } from 'src/app/shared/services/shared.service';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { UserApiService } from 'src/app/shared/services/user-api.service';
import { environment } from 'src/environments/environment.swbeta';
import { UserOnboardingServeComponent } from 'src/app/shared/components/user-onboarding-serve/user-onboarding-serve.component';
import {
   Country,
   CountryCodeService,
} from 'src/app/shared/services/phone-code.service';
import { HttpErrorResponse } from '@angular/common/http';
import { lastValueFrom, takeUntil } from 'rxjs';
import { FirebaseRemoteConfigService } from 'src/app/shared/services/firebase-remote-config.service';
import { TypesenseService } from 'src/app/shared/services/typesense.service';
// import { QuestionnaireModalComponent } from 'src/app/cabinet/questionnaire-modal/questionnaire-modal.component';
import { ReferrerTrackingService } from 'src/app/shared/services/referrer-tracking.service';
import { ReturnUrlService } from 'src/app/shared/services/return-url.service';
interface UserData {
   email: string;
   firstname: string;
   lastname: string;
   password: string;
   mobile: string;
   countryCode: string;
}

@Component({
    selector: 'app-signup-form',
    templateUrl: './signup-form.component.html',
    styleUrls: ['./signup-form.component.scss'],
    standalone: false
})
export class SignupFormComponent implements OnInit {
   isEmailVerified: boolean = false;
   isMobileVerified: boolean = false;
   formInitComplete: boolean = false;
   showPassword: boolean = false;
   isVerificationPinSent: boolean = false;
   signupForm!: UntypedFormGroup;
   showSignUpLoader: boolean = false;
   identifier!: string;
   errorMessage: string = '';
   nextResendDuration: number = environment.resendPinSeconds;
   seconds: number = this.nextResendDuration;
   showMailLoader: boolean = false;
   isOTPMailSent: boolean = false;
   showPinInput: boolean = false;
   showOTPLoader: boolean = false;
   isReadonly: boolean = false;
   source: string = 'Email';
   emailSendOtpApi: string = '';
   mobileSendOtpApi: string = '';
   emailVerificationApi: string = '';
   mobileVerificationApi: string = '';
   @Input() verificationRequired: boolean = true;
   @Input() action: string | null = null;
   @Input() isInsidePopup: boolean = false;
   @Input() selectedUI: 'default' | 'waitlist' = 'default';
   @Input() headerText: string = 'Join Musaffa!';
   @Input() subheaderText: string = '';
   @Output() formChange: EventEmitter<string> = new EventEmitter();
   countryISO: string = '';
   countries: Country[] = [];
   showUnverifiedError: boolean = false;
   isMobileVerificationEnabled: boolean = false;
   verifiedEmail: string = '';
   countryCode: string = '';
   takeMobileNo: boolean = false;
   showWaitlistSignupForm: boolean = false;
   private disableQuestionnaire = false;

   constructor(
      public analyticsUtils: AnalyticsUtils,
      private fb: UntypedFormBuilder,
      private userApiService: UserApiService,
      private toaster: ToastrService,
      private auth: AuthService,
      private subscriptionService: SubscriptionService,
      private router: Router,
      private sharedService: SharedService,
      private countryCodeService: CountryCodeService,
      private userApiServices: UserApiService,
      private modalService: NgbModal,
      private cdr: ChangeDetectorRef,
      private firebaseRemoteConfigService: FirebaseRemoteConfigService,
      private typesenseService: TypesenseService,
      private route: ActivatedRoute,
      private referrerTrackingService: ReferrerTrackingService,
      private returnUrlService: ReturnUrlService
   ) { }



   async ngOnInit(): Promise<void> {
      this.returnUrlService.captureReturnUrl();
      this.countries = this.countryCodeService.countries;
      let firstName = '';
      let lastName = '';
      let email = '';
      let mobile = '';
      let countryCode = '';
      let country = await this.userApiService.getUserCountryCode();
      if (country.length) {
         countryCode = this.countries.find((c) => c.code === country)?.dial_code ?? '';
      }
      this.countryISO = country.toUpperCase();
      this.countryCode = countryCode;

      if (!this.verificationRequired) {
         this.isEmailVerified = true;
         this.cdr.detectChanges();
         const user = await lastValueFrom(this.userApiServices.getUserData(true));
         this.source = user.registration_type;
         this.verifiedEmail = user.email;
         if (user) {
            firstName = user.firstname ?? '';
            lastName = user.lastname ?? '';
            email = user.email ?? '';
            mobile = user.phone ?? '';
         }
         // this.analyticsUtils.SignupFlow_SaveUser_Completed(this.source.toLowerCase());
      }
      const formGroup: any = {
         firstName: [firstName, [Validators.required]],
         lastName: [lastName, [Validators.required]],
         email: [
            email,
            [
               Validators.email,
               Validators.required,
               Validators.pattern(
                  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+([a-z]{1,15})\b/
               ),
            ],
         ],
         countryCode: [countryCode, [Validators.required]],
      };

      if (this.takeMobileNo) {
         formGroup.mobile = [
            '',
            [
               Validators.required,
               Validators.pattern(/^[0-9]*$/),
               Validators.minLength(7),
               Validators.maxLength(11),
            ],
         ];
      }

      if (this.verificationRequired) {
         formGroup.password = [
            '',
            [
               Validators.minLength(7),
               Validators.required,
               Validators.pattern(
                  '(?!.* )(?=\\D*\\d)(?=[^a-z]*[a-z])(?=[^A-Z]*[A-Z]).{7,30}'
               ),
            ],
         ];
         formGroup.code = ['', [Validators.minLength(4), Validators.required]];
      }
      this.signupForm = this.fb.group(formGroup);
      this.formInitComplete = true
      const verificationDefaults = await this.typesenseService.getFrontendConfig();
      // const verificationDefaults = {
      //    mobile_verification_defaults: {
      //       enabled: false,
      //       disabled_countries: []
      //    }
      // }
      this.isMobileVerificationEnabled = this.takeMobileNo && verificationDefaults.mobile_verification_defaults.enabled
         && !verificationDefaults.mobile_verification_defaults.disabled_countries.some((country: string) => this.countryISO === country);
      // Override for testing
      // this.isMobileVerificationEnabled = true;
      if (!this.isMobileVerificationEnabled) {
         this.isMobileVerified = true;
      }
   }

   onEmailVerifiedChange(event: boolean) {
      this.isEmailVerified = event;
      if (this.isEmailVerified) {
         this.verifiedEmail = this.signupForm.value.email;
         this.analyticsUtils.SignupFlow_SaveUser_Completed(this.source.toLowerCase());
      }
   }

   onMobileVerifiedChange(event: boolean) {
      this.isMobileVerified = event;
   }

   isFormValid() {
      return (
         this.signupForm.controls.firstName.valid &&
         this.signupForm.controls.lastName.valid &&
         this.signupForm.controls.email.valid &&
         (!this.takeMobileNo || (this.signupForm.controls.mobile.valid && this.signupForm.controls.countryCode.valid)) &&
         (!this.verificationRequired || this.signupForm.controls.password.valid)
      );
   }

   onCountryCodeChange(event: any) {
      this.signupForm.controls.countryCode.setValue(event.dial_code);
   }

   getUserData() {
      const userData = {
         email: this.verifiedEmail,
         firstname: this.signupForm.value.firstName,
         lastname: this.signupForm.value.lastName,
         password: this.signupForm.value.password,
         ...(this.takeMobileNo ? {
            mobile: this.signupForm.value.countryCode + this.signupForm.value.mobile
         } : {}),
      };
      return userData;
   }

   async sendVerificationMail() {

      if (!this.isFormValid()) {
         return;
      }
      this.errorMessage = '';
      const userData = this.getUserData();
      this.analyticsUtils.SignupFlow_OTPScreen_Opened(userData.email);
      try {
         this.showMailLoader = true;
         const resp =
            await this.userApiService.sendVerificationMail<VerificationMailResponse>(
               userData
            );

         if (resp.status) {
            if (resp.data.is_new) {
               this.identifier = resp.data.identifier;
               this.showMailLoader = false;
               this.isOTPMailSent = true;
               this.signupForm.controls.code.setValue('');
               this.signupForm.controls.code.markAsUntouched();
               this.inputTimer();
               this.analyticsUtils.SignupFlow_RegistrationScreen_SignupCompleted(
                  userData.email
               );
               this.toaster.success('Verification Pin sent');
            } else {
               this.errorMessage = resp.message;
               this.showMailLoader = false;
            }
         } else {
            this.errorMessage = resp.message;
            this.analyticsUtils.SignupFlow_RegistrationScreen_Failed(
               userData.email,
               this.errorMessage
            );
            this.showMailLoader = false;
         }
      } catch (error) {
         console.error(error);
         this.showMailLoader = false;
      } finally {
         this.showMailLoader = false;
      }
   }

   async registerUser() {
      if (!this.isFormValid()) {
         return;
      }
      this.showMailLoader = true;
      if (!this.takeMobileNo || (this.takeMobileNo && this.signupForm.value.mobile)) {
         const userData = this.getUserData();
         try {
            const resp: any = await this.userApiService.registerUser(userData);
            if (resp.status) {
               this.referrerTrackingService.clearReferrerData();
               this.auth.setToken(resp.data.token);
               await this.subscriptionService.setUserSubscriptionInfo();
               const subInfo = SubscriptionService.subscriptionData.getValue();

               if (subInfo.role === 'FREEMIUM') {
                  this.sharedService.openUpgradePopup();
                  // this.subscriptionService.openPaywallModal();
               }
               const fetchedUserData =
                  await this.userApiService.fetchUserDetailsAndSave();
               // this.analyticsUtils.SignupFlow_SaveUser_Completed(this.source.toLowerCase());
               this.analyticsUtils.sendDefaultSignup('email');
               this.analyticsUtils.sendSignupCompleted();
               this.sharedService.afterSignUpActions(fetchedUserData.email);
               this.signupForm.controls.firstName.setValue(fetchedUserData.firstname);
               this.signupForm.controls.lastName.setValue(fetchedUserData.lastname);
               this.auth.setLoggedIn();
               if (!this.isInsidePopup) {
                  // Check return_url first, then fall back to redirect query param, then default
                  const returnUrl = this.returnUrlService.getReturnUrl();
                  if (returnUrl) {
                     this.returnUrlService.redirectAfterAuth('/', resp.data.token);
                  } else {
                     const queryParams = this.route.snapshot.queryParams;
                     if (queryParams['redirect']) {
                        const url = this.router.parseUrl(decodeURIComponent(queryParams['redirect']));
                        this.router.navigateByUrl(url);
                     } else {
                        this.router.navigate(['/'], { replaceUrl: true });
                     }
                  }

                  // this.modalService.open(UserOnboardingServeComponent, {
                  //    modalDialogClass: 'paywall-popup-modal',
                  //    centered: true,
                  //    scrollable: true,
                  //    size: 'xl',
                  // });
                  // if(queryParams['onboarding_questions'] !== 'true') {
                  // if (this.shouldOpenQuestionnaire()) {
                  //    this.modalService.open(QuestionnaireModalComponent, {
                  //       modalDialogClass: 'paywall-popup-modal',
                  //       centered: true,
                  //       scrollable: true,
                  //       backdrop: 'static',
                  //       size: 'lg',
                  //    });
                  // }
                  // }
               } else {
                  this.auth.closeAuthPopup();
                  window.location.reload();
               }
               this.showSignUpLoader = false;
            } else {
               this.toaster.error(resp.message);
               // this.analyticsUtils.SignupFlow_VerifyOTP_Failed(
               //    this.signupForm.value.email,
               //    resp.message
               // );
               this.signupForm.controls.code.setValue('');
               this.signupForm.controls.code.markAsUntouched();
               this.showSignUpLoader = false;
            }
         } catch (error) {
            this.toaster.error('An error occurred during registration. Please try again.');
            this.showSignUpLoader = false;
         }
      }
      this.showMailLoader = false;
   }

   getLoginLinkPath(): string {
      return '/authentication/login';
   }

   getLoginLinkQueryParams(): { [key: string]: string } {
      return this.route.snapshot.queryParams;
   }

   private shouldOpenQuestionnaire(): boolean {
      // Case 1: Signup inside popup → never open
      if (this.isInsidePopup) {
         return false;
      }

      // Case 2: Pricing page or any route that disables questionnaire
      const disableFromRoute = this.route.snapshot.data?.['disableQuestionnaire'] === true;

      if (disableFromRoute) {
         return false;
      }

      // Case 3: Redirect / return URL exists
      const returnUrl = this.returnUrlService.getReturnUrl();
      if (returnUrl) {
         return false;
      }

      return true;
   }

   inputTimer() {
      this.showPinInput = true;
      let interval = setInterval(() => {
         if (this.seconds == 0) {
            clearInterval(interval);
            this.showPinInput = false;
            this.seconds = this.nextResendDuration;
            this.signupForm.controls.code.markAsUntouched();
         } else {
            this.seconds--;
         }
      }, 1000);
   }

   async resendOTPMail() {
      try {
         this.showOTPLoader = true;
         const userEmail = {
            email: this.signupForm.value.email,
         };
         this.analyticsUtils.resend_otp_tapped();

         let res = await this.userApiService.sendOTPMail<OTPMailResponse>(
            userEmail
         );
         if (res.status) {
            this.identifier = res.data.identifier;
            this.showOTPLoader = false;
            this.inputTimer();
         }
      } catch (error) {
         console.error(error);
         this.showOTPLoader = false;
      } finally {
         this.showOTPLoader = false;
      }
   }

   submitSignupForm(event: Event) {
      event.preventDefault();
      if (this.isEmailVerified && this.isMobileVerified) {
         if (this.verificationRequired) {
            this.registerUser();
         } else {
            this.saveUser();
         }
      } else {
         // if(!this.isEmailVerified && !this.isMobileVerified) {
         //    this.toaster.error('Please verify your email and mobile number');
         // } else if(!this.isEmailVerified) {
         //    this.toaster.error('Please verify your email');
         // } else {
         //    this.toaster.error('Please verify your mobile number');
         // }
         this.showUnverifiedError = true;
      }
   }

   async saveUser() {
      this.showMailLoader = true;
      // if(this.signupForm.value.mobile) {
      if (!this.takeMobileNo || (this.takeMobileNo && this.signupForm.value.mobile)) {
         // const resp: any = await this.userApiService.activateUser({mobile: userData.mobile});
         const userData = this.getUserData();
         const resp: any = await this.userApiService.registerUser(userData);
         if (resp.status) {
            this.referrerTrackingService.clearReferrerData();
            // this.analyticsUtils.SignupFlow_SaveUser_Completed(this.source.toLowerCase());
            this.analyticsUtils.sendDefaultSignup('email');
            this.analyticsUtils.sendSignupCompleted();
            // this.modalService.open(UserOnboardingServeComponent, {
            //    centered: true,
            //    scrollable: true,
            //    size: 'xl',
            //    modalDialogClass: 'paywall-popup-modal',
            // });
            // if (this.shouldOpenQuestionnaire()) {
            //    this.modalService.open(QuestionnaireModalComponent, {
            //       modalDialogClass: 'paywall-popup-modal',
            //       centered: true,
            //       scrollable: true,
            //       backdrop: 'static',
            //       size: 'lg',
            //    });
            // }
            this.router.navigate(['/']);
         }
      }
      // }
      this.showMailLoader = false;
   }


   async activationCode(event: Event) {
      event.preventDefault();
      this.showSignUpLoader = true;
      const activationCode = this.signupForm.value.code
         .trim()
         .replace(/\s/g, '');
      this.analyticsUtils.SignupFlow_VerifyOTP_Tapped(
         this.signupForm.value.email
      );

      let request = {
         identifier: this.identifier,
         activationCode: activationCode,
      };

      try {
         let resp = await this.userApiService.verifyOTPCode<VerifyOTPResponse>(
            request
         );
         if (resp.status) {
            this.referrerTrackingService.clearReferrerData();
            this.auth.setToken(resp.data.token);
            await this.subscriptionService.setUserSubscriptionInfo();
            const subInfo = SubscriptionService.subscriptionData.getValue();

            if (subInfo.role === 'FREEMIUM') {
               this.sharedService.openUpgradePopup();
               // this.subscriptionService.openPaywallModal();
            }
            const userData =
               await this.userApiService.fetchUserDetailsAndSave();
            this.analyticsUtils.SignupFlow_VerifyOTP_Completed(userData.email);
            this.sharedService.afterSignUpActions(userData.email);
            this.signupForm.controls.firstName.setValue(userData.firstname);
            this.signupForm.controls.lastName.setValue(userData.lastname);
            this.auth.setLoggedIn();
            const returnUrl = this.returnUrlService.getReturnUrl();
            if (returnUrl) {
               this.returnUrlService.redirectAfterAuth('/', resp.data.token);
            } else {
               this.router.navigate(['/'], { replaceUrl: true });
            }
            this.showSignUpLoader = false;

            // this.modalService.open(UserOnboardingServeComponent, {
            //    modalDialogClass: 'paywall-popup-modal',
            //    centered: true,
            //    scrollable: true,
            //    size: 'xl',
            // });
            // if (this.shouldOpenQuestionnaire()) {
            //    this.modalService.open(QuestionnaireModalComponent, {
            //       modalDialogClass: 'paywall-popup-modal',
            //       centered: true,
            //       scrollable: true,
            //       backdrop: 'static',
            //       size: 'lg',
            //    });
            // }
         } else {
            this.toaster.error(resp.message);
            this.analyticsUtils.SignupFlow_VerifyOTP_Failed(
               this.signupForm.value.email,
               resp.message
            );
            this.signupForm.controls.code.setValue('');
            this.signupForm.controls.code.markAsUntouched();
            this.showSignUpLoader = false;
         }
      } catch (error) {
         this.showSignUpLoader = false;
      } finally {
         this.showSignUpLoader = false;
      }
   }

   signIn() {
      this.formChange.emit('signIn');
   }

   togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
   }

   @HostBinding('class')
   get formStyling(): string {
      if (this.isInsidePopup) {
         return 'form-styling';
      } else {
         return '';
      }
   }

   @ViewChild('tooltipRef', { static: true }) tooltip!: NgbTooltip;

}
